<template>
    <div class="nuevo-destinatario">
        <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"/>
        <b-card style="margin: 20px">
            <b-card-header header-tag="header" class="p-1" role="tab">Nuevo destinatario</b-card-header>
            <b-card-body>
                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label style="color: #ff5855">Ingresa los datos para agregar a tu agenda</label>
                    </div>
                </div>  

                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <label>Ingresa el alias o el número de CBU/CVU</label> 
                    </div>
                </div> 

                <div class="row form-group">
                    <div class="col-md-12">
                        <label>Modo de transferencia</label>
                        <KitsCombo
                            v-model="model.modoTransferenciaID"
                            v-bind:items="modosTransferencias"
                            propertyName="Description"
                            propertyID="EntityID"
                            nullText=" -- Seleccione un modo de transferencia -- "
                            :todos="false"
                        />
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12">
                        <label v-text="inputTitle"></label>
                        <base-input v-if="model.modoTransferenciaID == 1" type="number" v-model="model.inputValue" :placeholder="placeholderInput"></base-input>
                        <base-input v-if="model.modoTransferenciaID == 2" v-model="model.inputValue" :placeholder="placeholderInput"></base-input>
                    </div>
                </div>

                <div class="row form-group">
                    <div class="col-md-12 text-center">
                        <b-button class="btn btn-danger" @click="validateContact()">Verificar</b-button>                        
                    </div>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>
<style lang="scss">
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>

<script>
import Vue from 'vue'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';
import axiosHelpers from "@/helpers/axiosHelpers";
import KitsCombo from "@/components/KitsCombo";
import notificationHelpers from '@/helpers/notificationHelpers';

export default {
    name: "NuevoDestinatario",
    components: { 
        KitsCombo,
        notificationHelpers
    },
    data() {
        return {
            model: {   
                modoTransferenciaID: null,
                inputValue: '',
                hash: '',
                contact: null
            },
            modosTransferencias: []
        };
    },
    computed: {
        placeholderInput() {
            return this.model.modoTransferenciaID == 2 ? "6 a 20 digitos alfanúmericos" : "22 digitos númericos, sin espacios ni guiones";
        },
        inputTitle() {
            return this.model.modoTransferenciaID == 2 ? "Ingrese el Alias" : "Ingrese el CBU/CVU";
        }        
    },
    methods: {
       async getTransferenceModes(context) {
            axiosHelpers.axiosGet(
                "TransferenceContact/GetTransferenceModes", 
                {}, 
                context, 
                function(data) {
                    context.modosTransferencias = data.ResponseVM.TransferenceModes;
                    context.model.modoTransferenciaID = data.ResponseVM.TransferenceModes[0].EntityID;
                }
            );
        },
        validateContact() {
            let context = this;

            if (context.model.inputValue == undefined || context.model.inputValue == '') {
                notificationHelpers.showWarning(
                    "Advertencia!",
                    "Debe ingresar un Alias o CBU/CVU",
                    context
                );
                
                return;
            }

            this.$validator.validate().then(valid => {
                if (valid) {
                    axiosHelpers.axiosPost(
                        "TransferenceContact/CheckCBUCVUAccount",
                        {
                            CBU: context.model.modoTransferenciaID == 1 ? context.model.inputValue : '',
                            Alias: context.model.modoTransferenciaID == 2 ? context.model.inputValue : ''
                        },
                        this,
                        function(data) {
                            if(data.Alerts.length == 0) {
                                data.ResponseVM.Contact.IsAlias = context.model.modoTransferenciaID == 2;

                                context.$router.push({ 
                                    name: "ConfirmarNuevoDestinatario", 
                                    params: { 
                                        propContact: data.ResponseVM.Contact,
                                        propHash: data.ResponseVM.Hash
                                    }
                                });
                            }
                        }
                    );
                } else {
                    notificationHelpers.showWarning(
                        "Advertencia!",
                        "Verifique los campos",
                        context
                    );
                }
            });
        }    
    },
    beforeMount() {
        this.getTransferenceModes(this);
    }
}
</script>